module.exports = __webpack_public_path__ + "img/Northern-Cyprus.83c19afb.png";